import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/equity',
  component: LAYOUT,
  name: 'Equity',
  redirect: '/equity/index',
  meta: {
    title: '权益详情',
  },
  children: [
    {
      path: 'index',
      name: 'EquityIndex',
      meta: {
        title: '权益详情',
      },
      component: () => import('@/views/equity/index'),
    },
    {
      path: 'detail',
      name: 'EquityIndex',
      meta: {
        title: '权益详情', // 权益说明
      },
      component: () => import('@/views/equity/detail'),
    },
    {
      path: 'rule',
      name: 'EquityRule',
      meta: {
        title: '升级规则',
      },
      component: () => import('@/views/equity/rule'),
    },
    {
      path: 'explain',
      name: 'EquityExplain',
      meta: {
        title: '权益说明',
      },
      component: () => import('@/views/equity/explain'),
    },

  ],
};
